export default "__VITE_ASSET__cbef32fa__"